import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { RequestService } from 'src/app/service/request.service';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss'],
})
export class RequestsComponent {
  requests: any = {};
  requestId: string = '';
  fetchingData: boolean = false;
  individualRequest: any = {};
  modalTitle: string = 'Request Details';
  isModalOpen2: boolean = false;
  webhookConfig: any = {};
  webhookId: string;
  data: any;
  fromDate: any;
  toDate: any;
  responseState: string = '';
  method: string = '';
  limit: number = 25;
  page: number = 1;
  totalList: number = 0;
  searchRequest: string = '';

  tableHeaders: string[] = [
    'Name',
    'Type',
    'Resend',
    'Resend Duration',
    'URL',
    'Status',
    'Trials',
    'Created At',
  ];
  tableData: any[] = [];

  constructor(private requestService: RequestService, private router: Router) {
    const date = new Date();
    this.fromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    // console.log(this.fromDate);
    this.toDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    // console.log(this.toDate);
    // this.fromDate = new Date()

    // console.log(this.fromDate);

    this.data = [
      {
        type: 'search',
        name: 'Search',
        label: 'Search by Id',
        value: '',
        defaultValue: '',
        placeHolder: 'search...',
      },
      {
        type: 'date-range',
        name: 'date-range',
        label: 'Date Range',
        fromDate: this.fromDate,
        toDate: this.toDate,
        fromDateValue: '',
        toDateValue: '',
      },
      // {
      //   type: 'select',
      //   name: 'status',
      //   label: 'Status',
      //   value: '',
      //   defaultValue: '',
      //   options: [
      //     { key: '', value: 'All' },
      //     { key: 'completed', value: 'Completed' },
      //     { key: 'incomplete', value: 'Incomplete' },
      //   ],
      // },
      {
        type: 'select',
        name: 'method',
        label: 'Method',
        value: '',
        defaultValue: '',
        options: [
          { key: '', value: 'All' },
          { key: 'POST', value: 'POST' },
          { key: 'GET', value: 'GET' },
        ],
      },
      {
        type: 'input',
        name: 'responseState',
        label: 'ResponseState',
        value: '',
        defaultValue: '',
        placeHolder: '200',
      },
    ];
  }

  ngOnInit() {
    this.getRequests();
  }

  getObjectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  onFilterChanged(value: any) {
    // console.log(value);
    this.searchRequest = value[0].value;
    this.fromDate = value[1].fromDateValue;
    this.toDate = value[1].toDateValue;
    this.method = value[2].value;
    this.responseState = value[3].value;
    // console.log(this.fromDate);
    // console.log(this.toDate);
    this.getRequests();
  }
  refreshRequests() {
    this.page = 1;
    this.getRequests();
  }

  singleRequest = (id: string | number) => {
    this.individualRequest = this.requests.find(
      (obj: { _id: string | number }) => obj._id === id
    );
    // console.log(this.individualRequest);
    if (this.individualRequest) {
      this.webhookConfig = this.individualRequest.webhookConfig;
      this.isModalOpen2 = true;
    }
  };
  closeModal = () => {
    this.isModalOpen2 = false;
  };

  getRequests() {
    this.fetchingData = true;
    this.requestService
      .getRequests(
        this.page - 1,
        this.limit,
        this.fromDate,
        this.toDate,
        this.responseState,
        this.method,
        this.searchRequest,
        this.webhookId
      )
      .subscribe({
        next: (res: any) => {
          this.requests = res.data;
          // console.log(this.requests);
          this.totalList = res.totalNum;
          // console.log(this.info)
          if (this.requests.length > 0) {
            for (let i = 0; i < this.requests.length; i++) {}
            this.tableData = this.requests?.map((i: any, n: number) => {
              return [
                i._id,
                i.webhookConfig.name,
                i.webhookConfig.type,
                i.webhookConfig.resend,
                i.webhookConfig.resendDuration,
                i.url,
                i.responseStatus,
                i.trials,
                i.createdAt,
              ];
            });
          } else {
            this.tableData = [];
          }
          this.fetchingData = false;
          error: (error: any) => {
            // this.fetchingData = false;
          };
        },
      });
  }
}
